import { message } from 'antd';
import { createDocumentEditRequests } from '../../../../services/popupApi';

// Used only when the popup was opened without a module (e.g. a hand-built
// navigate). The gateway refuses modules not enabled for edit approval, so a
// wrong module cannot silently raise requests elsewhere.
const DEFAULT_MODULE = 'documents';

export const api = {
  submit: async (values, context) => {
    const result = await createDocumentEditRequests({
      module: context.moduleName || DEFAULT_MODULE,
      documentIds: context.selectedIds ?? [],
      reason: String(values.reason ?? '').trim(),
    });

    // Nothing raised → the gateway answers 409, already thrown above, so the
    // popup stays open with the reason. Here some were raised and some skipped
    // (e.g. a document that already has an active request): the popup still
    // closes on success, so say what was skipped instead of hiding it.
    const failedCount = Number(result?.failedCount) || 0;
    if (failedCount > 0) {
      const createdCount = Number(result?.createdCount) || 0;
      const firstError = result?.failures?.find((failure) => failure?.error)?.error;
      message.warning(
        `${createdCount} of ${createdCount + failedCount} edit requests raised${firstError ? ` — ${firstError}` : ''}.`,
      );
    }
  },
};
